export default {"src":"/_next/static/media/chevronRightUiRed_16.5584d95b.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};